multiSubmitHandler = (selector)->

    if $(selector + ' :submit').length < 2 # zjistim si jestli jsou v zadanem selectoru vic jak jeden submit button
        return true # pokud ne, necham ho byt
    else # pokud jo, zavesim se na submit event
        $(selector).on "submit", (event)->
            _tabs = []
            _active_tab = $(selector).find('.nav-tabs .active a').attr('href').split('#')[1] # jaky je aktualni tab?
            _active_submit = $('#' + _active_tab + ' :submit').first() # najdu na aktivnim tabu prvni submit button (mel by byt jeden, ale vic buttonu neresim)
            console.warn _active_submit
            $(selector).find('.nav-tabs :not(.active) a').each ()-> # vytahnu si id vsech tabu
                _tabs.push $(this).attr('href').split('#')[1]

            _form_data = $(this).serializeArray()

            _filtered_data = _.filter(_form_data, (item)->
                parts = item.name.split('-')
                if parts.length > 1
                    return _.indexOf(_tabs, parts[0]) < 0 # true/false

                else
                    return true
            )

            # a doplnim do nej info o buttonu, ktery je na aktivnim tabu
            event.data = _.extend(_filtered_data, [{
                name:_active_submit.attr('name')
                value:_active_submit.val()
            }])

tabHandler = (selector)->
    if selector?
        $(selector + ' a').click (e)->
            e.preventDefault()
            closeButton = $('.alert.alert-dismissable button')
            if closeButton? and closeButton.length > 0
                closeButton.click()
            $(this).tab("show")

        # store the currently selected tab in the hash value
        $("ul.nav-tabs > li > a").on "shown.bs.tab", (e)->
            id = $(e.target).attr("href").substr(1)
            window.location.hash = "!" + id

        # on load of the page: switch to the currently selected tab
        hash = window.location.hash.substr(2)
        $(selector + ' a[href="#' + hash + '"]').tab('show')
    else
        false

onceAnimate = ($element,cssClass)->
    $element.addClass(cssClass)
    $element.one 'webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd MSAnimationEnd animationend', ()->
        $element.removeClass(cssClass)